import $ from "jquery";

// TODO: use native stuff instead of jquery

const clearSessionStorage = function () {
  console.log("Clearing current session storage, in login.js");
  window.sessionStorage.clear();
};

const testJavaScript = function () {
  $("#NO_JS").css("display", "none");

  $("#txtUserName").trigger("focus");
};

const testBrowserVersion = function () {
  //hide old browser remark if documentMode is ok
  $("#divOldBrowser").toggle(document.documentMode < 9);
};

const clearBearerCookie = function () {
  console.log("Deleting bearer cookie");
  document.cookie = "Bearer" + "=; Max-Age=-99999999;";
};

export {
  clearSessionStorage,
  testJavaScript,
  testBrowserVersion,
  clearBearerCookie,
};
